export default __webpack_public_path__ + "static/media/tw-white.9b800842.svg";